/* eslint-disable no-nested-ternary */
import { useState } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQuery";
import Mixpanel from "../../utils/Mixpanel";
import config from "../../config";
import Button from "../Buttons/Button";
import useBranchIoLinkGeneration from "../../utils/BranchIO";
import { getUrlPath } from "../../utils/helpers";
import { useWindowResize } from "../../utils/hooks";
import Image from "../Image";
import { BRANCH_APP_DOWNLOAD_CAMPAIGNS } from "../../utils/constants";

const Modal = dynamic(() => import("../Modal/Modal"));

const ModalContent = dynamic(() => import("../ModalContent/ModalContent"));

const MemberProfileList = ({
	member,
	pageType,
	source,
	className,
	isEmployerPage,
	customUtmMedium,
}) => {
	const router = useRouter();
	const [isMobileView] = useWindowResize();

	const memberExperienceString =
		member && member.experience_in_years && parseInt(member.experience_in_years, 10)
			? parseInt(member.experience_in_years, 10) > 1
				? `${parseInt(member.experience_in_years, 10)} yrs.`
				: `${parseInt(member.experience_in_years, 10)} yr.`
			: "Fresher";

	const [connectUrl] = useBranchIoLinkGeneration({
		section: `Members_Profile_Connect_Button_Click`,
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.redirectCountdownModal,
		pageType: source,
		customUtmMedium,
	});
	const [messageUrl] = useBranchIoLinkGeneration({
		section: `Members_Profile_Message_Button_Click`,
		campaign: BRANCH_APP_DOWNLOAD_CAMPAIGNS.redirectCountdownModal,
		pageType: source,
		customUtmMedium,
	});
	const [linkType, setLinkType] = useState("connect");
	const [openModal, setOpenModal] = useState(false);

	const toggleModal = (type) => {
		setLinkType(type);
		setOpenModal(!openModal);
	};

	const trackHireNowClick = () => {
		Mixpanel.track("Hire Now Button Click", {
			"Member Name": member.full_name,
			source,
			pageType,
			page: getUrlPath(),
			"Member Experience": memberExperienceString,
		});
	};

	const handleConnectClick = () => {
		toggleModal("connect");
		Mixpanel.track("Connect User Click", {
			"Member Name": member.full_name,
			source,
			pageType,
			page: getUrlPath(),
			"Member Experience": memberExperienceString,
		});
	};

	const handleMessageClick = () => {
		toggleModal("message");
		Mixpanel.track("Message User Click", {
			"Member Name": member.full_name,
			source,
			pageType,
			page: getUrlPath(),
			"Member Experience": memberExperienceString,
		});
	};
	const baseUrlGumlet = "https://cdn.apna.co";

	return (
		<Container className={className}>
			<Wrapper>
				<MembersImageTextContainer>
					<MembersImageTextWrapper>
						<MembersImageContainer>
							<MembersImageWrapper>
								<UserImage
									src={
										member?.photo_firebase_path
											? `/${member?.photo_firebase_path.slice(
													baseUrlGumlet.length
											  )}?mode=crop&crop=faces&h=96&`
											: ""
									}
									alt={`${member && member.full_name} Profile Image`}
									height={96}
									width={96}
								/>
							</MembersImageWrapper>
						</MembersImageContainer>
						<MembersTextContainer>
							<MemberHeadingContainer>
								<MemberHeadingWrapper>
									<MemberHeadingWrapper>
										<MemberMainHeading>
											{member && member.full_name}
										</MemberMainHeading>
										<MemberSubHeading>
											{(member && member.company) || ""}
										</MemberSubHeading>
										<MobSubHeading className="d-mobile">
											{member && member.area}
										</MobSubHeading>
									</MemberHeadingWrapper>
								</MemberHeadingWrapper>
								{isEmployerPage && (
									<ActionButtons
										as="a"
										target="_blank"
										href={`${config.dashboardUrl}/login?utm_source=${
											(router.query && router.query.utm_source) ||
											"Website"
										}&utm_medium=${
											(router.query && router.query.utm_medium) ||
											"Candidate%20Hire%20Now%20Button"
										}&utm_campaign=${
											(router.query && router.query.utm_campaign) ||
											source
										}&employer=true`}
										onClick={trackHireNowClick}
									>
										Hire now
									</ActionButtons>
								)}
							</MemberHeadingContainer>
							<MetadataContainer>
								<MetadataWrapper>
									<MetadataContent>
										<MetadataHeading>Exp.</MetadataHeading>
										<MetadataValue>
											{memberExperienceString}
										</MetadataValue>
									</MetadataContent>
									<MetadataContent>
										<MetadataHeading>Education</MetadataHeading>
										<MetadataValue>
											{member && member.education_level}
										</MetadataValue>
									</MetadataContent>
									<MetadataContent>
										<MetadataHeading>Location</MetadataHeading>
										<MetadataValue>
											{member && member.area}
										</MetadataValue>
									</MetadataContent>
								</MetadataWrapper>
							</MetadataContainer>
							<ActionButtonsContainer>
								<ActionButtonsWrapper>
									{isMobileView && !isEmployerPage && (
										<>
											<ActionButtons onClick={handleConnectClick}>
												Connect
											</ActionButtons>
											<ActionButtons
												secondary
												onClick={handleMessageClick}
											>
												Message
											</ActionButtons>
										</>
									)}
									{!isMobileView && !isEmployerPage && (
										<>
											<ActionButtons
												as="a"
												href={`${
													config.dashboardUrl
												}/?utm_source=${
													(router.query &&
														router.query.utm_source) ||
													"job-groups-page"
												}&utm_medium=${
													(router.query &&
														router.query.utm_medium) ||
													"Candidate%20Hire%20Now%20Button"
												}&utm_campaign=${
													(router.query &&
														router.query.utm_campaign) ||
													source
												}&employer=true`}
												onClick={trackHireNowClick}
											>
												Hire now
											</ActionButtons>
											<Link
												as="a"
												href={config.websiteUrl + member.slug}
												rel="noopener noreferrer"
												onClick={() => {
													Mixpanel.track(
														`${source} Member Detail Link Click`,
														{
															"member Name":
																member.full_name,
															"Profile URL": `${
																config.websiteUrl +
																member.slug
															}`,
															source,
															page:
																typeof window !==
																	"undefined" &&
																window.location.href,
														}
													);
												}}
											>
												Details
											</Link>
										</>
									)}
								</ActionButtonsWrapper>
							</ActionButtonsContainer>
						</MembersTextContainer>
					</MembersImageTextWrapper>
				</MembersImageTextContainer>

				<BottomLine />
			</Wrapper>
			<Modal
				isOpen={openModal}
				onRequestClose={toggleModal}
				shouldCloseOnOverlayClick={false}
			>
				<ModalContent
					pageType={source}
					url={linkType === "connect" ? connectUrl : messageUrl}
					toggleModal={toggleModal}
				/>
			</Modal>
		</Container>
	);
};

// Styles
const Container = styled.div``;
const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

const MemberHeadingContainer = styled.div`
	display: flex;
	justify-content: space-between;
`;
const MemberHeadingWrapper = styled.div`
	display: flex;
	flex-direction: column;
	${mediaMaxWidth.medium`
        justify-content: space-between;
    `};
`;
const MemberMainHeading = styled.h3`
	font-size: 16px;
	font-weight: 500;
	color: #373737;
	line-height: 1.2;
	margin-bottom: 3px;
	${mediaMaxWidth.small`
		padding-right: 10px;
	`};
`;
const MemberSubHeading = styled.p`
	font-size: 14px;
	color: #6a6a6a;
	margin-bottom: 4px;
	line-height: 20px;
`;
const MobSubHeading = styled.div`
	display: none;
	font-size: 12px;
	color: #a5a5a5;
	line-height: normal;
`;
const ActionButtonsContainer = styled.div``;
const ActionButtonsWrapper = styled.div`
	display: flex;
	margin-top: 15px;
	& button:last-child,
	& a:last-child {
		margin-left: 20px;
	}
`;
const ActionButtons = styled(Button)`
	height: 32px;
	line-height: 32px;
	display: inline-block;
	font-size: 14px;
	padding: 0 15px;
	text-decoration: none;
`;
const Link = styled.a`
	font-size: 14px;
	font-weight: 500;
	height: 32px;
	line-height: 32px;
	display: inline-block;
	color: #2bb793;
	text-decoration: none;
`;
const MetadataContainer = styled.div`
	margin-top: 13px;
`;
const MetadataContent = styled.div`
	display: flex;
	flex-direction: column;
	${mediaMaxWidth.small`
        margin-right: 0;
    `};
`;
const MetadataHeading = styled.div`
	font-size: 12px;
	letter-spacing: 0.45px;
	color: #a5a5a5;
	min-height: 23px;
`;
const MetadataValue = styled.div`
	font-size: 14px;
	color: #6a6a6a;
`;
const MetadataWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;

	& ${MetadataContent}:not(:last-child) {
		margin-right: 25px;
	}

	${mediaMaxWidth.small`
	    justify-content: space-between;
    `};
`;
const BottomLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: #eaeaea;
	margin-top: auto;
	margin-bottom: 24px;
`;
const MembersImageTextContainer = styled.div``;
const MembersImageTextWrapper = styled.div`
	display: flex;
`;
const MembersImageContainer = styled.div`
	margin-right: 20px;
`;
const MembersTextContainer = styled.div`
	width: 100%;
`;
const UserImage = styled(Image)``;
const MembersImageWrapper = styled.div`
	width: 96px;
	height: 96px;
	border-radius: 50%;

	& ${UserImage} {
		width: 96px;
		height: 96px;
		border-radius: 50%;
		object-fit: cover;
	}

	${mediaMaxWidth.medium`
		width: 56px;
		height: 56px;

		& ${UserImage} {
			width: 56px;
			height: 56px;
		}
	`}
`;

export default MemberProfileList;
